const en = {
  header: {
    search: "Search",
    downloadApp: "Download App"
  },

  common: {
    next: "Next",
    previous: "Previous",
    comingsoon: "Content will be updated soon.",
    pageTitle: "GoPaperless Agent | Quantera Joint Stock Company",
  },

  sidebar: {
    welcome: "Welcome",
    version: "Version",

    install: {
      title: "Installation Guide",
      itemInstall: "Install GoPaperless Agent",
      itemUninstall: "Uninstall GoPaperless Agent",
      itemGuideToAddingandTrustingDigitalCertificatesFromCAsOnMacOS: "Trust Certificate Authorities on macOS"
    },

    usage: {
      title: "User Guide",
      config: "Configure GoPaperless Agent",
      login: "Login to GoPaperless Agent",
      viewCert: "View Personal Digital Certificates",
      messageBox: "MessageBox Service",
      supportedSign: "Signature Authentication via VNeID"
    },

    cases: {
      title: "Use Cases",
      word: "Sign with Microsoft Word",
      excel: "Sign with Microsoft Excel",
      powerPoint: "Sign with Microsoft PowerPoint",
      outlook: "Sign with Microsoft Outlook",
      foxit: "Sign with Foxit Reader",
      pdfSign: "Sign with PDF Sign",
      acrobatReader: "Sign with Acrobat Reader",
      acrobatWriter: "Sign with Acrobat Writer"
    },

    pricing: "Pricing"
  },

  footer: {
    powered: "Powered by Mobile-ID"
  },

  copy: {
    copy: "Copy",
    copied: "Copied"
  },

  // ⭐ WELCOME SECTION
  welcome: {
    title: "Welcome",
    lastUpdatedBase: "Last updated",

    intro: {
      p1: "GoPaperless Agent – developed by Mobile-ID – is a middleware solution that enables secure digital signing and intelligent certificate management based on VNeID. Its strong technical advantages, such as multi-CA support, Adobe/Office integration, and automated certificate lifecycle management, position the product to compete effectively in Vietnam’s e-commerce and digital certificate market.",
      p2: "Eliminates the need for local hardware such as smart cards and USB tokens without changing the user experience.",
      p3: "Users can sign any document/file directly within their business applications without uploading it to hosted services. In addition, the application file format is preserved after signing, so there is no automatic conversion to PDF or other formats."
    },

    techOverview: {
      title: "Technical Overview",

      architecture: {
        title: "System Architecture",
        item1: "GoPaperless Agent operates as a secure middleware layer connecting VNeID, remote digital certificate authorities (CAs), and external applications. The architecture includes:",
        item2: "API Gateway: supports RESTful APIs connecting to VNeID and multiple CAs (e.g., VNPT, Viettel, FPT).",
        item3: "Authentication Module: uses VNeID Level 2 (OTP, biometrics).",
        item4: "Signing Engine: implements RSA/ECC encryption standards according to Vietnamese regulations.",
        item5: "Application Integration Layer: supports signing directly in Adobe, MS Office, tax/customs systems.",
        item6: "Certificate Lifecycle Management: automated issuance, renewal, and revocation."
      }
    },

    features: {
      title: "Key Features",
      item1: "VNeID integration – authentication and digital signing in one step.",
      item2: "Supports multiple remote CAs.",
      item3: "Direct signing within Adobe, Word, Excel, and business systems.",
      item4: "Automated certificate lifecycle management.",
      item5: "Complies with ISO 27001 and Vietnamese information security regulations.",
      item6: "Intuitive user interface."
    },

    download: {
      description: "Experience the GoPaperless Agent demo to see the remote digital signing process in action right within your application.",
      description2: "The GoPaperless Agent application is available on the Windows Store and the App Store. Please select your operating system (Windows or macOS) to download."
    },

    next: {
      title: "Next",
      version: "Version"
    },

    lastUpdated: "Last updated 1 month ago",
  },

  cookies: {
    title: "This website uses cookies",
    description: "By clicking 'Accept All', you agree to the storing of cookies on your device to enhance site navigation, analyze site usage, and assist in our marketing efforts.",
    preferences: "Cookie Preferences",
    rejectAll: "Reject All",
    acceptAll: "Accept All",

    preferencesTitle: "Custom Cookie Preferences",
    strictlyNecessary: "Strictly Necessary",
    strictlyNecessaryDesc: "These cookies are required for the website to function properly. They do not collect data for advertising purposes and cannot be disabled, as this would break the site's basic functionality.",
    alwaysActive: "Always Active",

    functional: "Functional / Preferences",
    functionalDesc: "These cookies remember your choices and settings to provide a more personalized experience, such as your selected language, dark/light theme, font size, region, or other customizations.",

    analytics: "Analytics / Performance",
    analyticsDesc: "These cookies help us understand how visitors interact with the site. All data is fully anonymized and used solely to improve site performance, loading speed, and content quality—no personal identification.",

    marketing: "Marketing / Advertising",
    marketingDesc: "These cookies enable us to show you more relevant ads on our site and across other platforms. They anonymously track your browsing behavior and prevent the same ad from appearing repeatedly.",

    savePreferences: "Save Preferences",
    cancel: "Cancel"
  },

  installationGuide: {
    operatingsystemrequire: "System Requirements:",
    operatingsystem: "Operating System: Windows 8 or later (Windows 8/10/11, 32-bit and 64-bit supported) or macOS 10.15 or later",
    adminstrator: "Software installation permission (Administrator)",
    internet: "Stable Internet connection",
    step: "Download and Installation Steps:",
    step1: "<strong>Step 1:</strong> Access the installation link:",
    step2: "<strong>Step 2:</strong> On the installation page, select the appropriate version for your operating system:",
    step3: "<strong>Step 3:</strong> Click the corresponding version to download the installation file to your computer.\nThe installation file will be saved in your device's default download folder.",
    step2a: "GoPaperless Agent – Windows (for Windows 8 or later)",
    step2b: "GoPaperless Agent – macOS (for macOS 10.15 or later)",
  },

  installationGopaperlessAgent: {
    stepinstall: "Installation Steps:",
    step1: "<strong>Step 1:</strong> Open the folder containing the downloaded installation file on your computer.",
    step2: "<strong>Step 2:</strong> Double-click the file <strong>GoPaperlessAgentInstaller.exe</strong> to begin the installation process.",
    step3: "<strong>Step 3:</strong> When the system displays a security notification (User Account Control), select <strong>Yes</strong> to allow the application to proceed with the installation.",
    step4: "<strong>Step 4:</strong> The system will display a welcome screen with installation instructions. Click the <strong>Next ></strong> button to continue the installation process.",
    step5: "<strong>Step 5:</strong> Read the License Agreement carefully. Check the box <strong>☑ I accept the terms of the License Agreement</strong>.",
    step6: "<strong>Step 6:</strong> Click the <strong>Install</strong> button to continue.",
    todo: "Please ensure the following:",
    todo1: "Wait until the installation process is fully completed.",
    todo2: "Do not close the installation window during this process.",
    todo3: "Do not shut down or restart your computer before the installation is complete.",
    todotime: "The installation process may take a few seconds to several minutes depending on your computer configuration.",
    note: "Notes:",
    note1: "If the installation process is interrupted, please restart the installation from the beginning.",
    note2: "If an error occurs, check your Administrator permissions or restart your computer and try again.",
    step7: "<strong>Step 7:</strong> Click the <strong>Finish</strong> button to complete the installation process. After clicking <strong>Finish</strong>, the system will automatically launch the <strong>GoPaperless Agent</strong> application.",
    completeclient: "The interface after successful installation will be displayed as shown in the image below. ",
  },

  guideToAddingandTrustingDigitalCertificatesFromCAsOnMacOS: {
    step1: "<strong>Step 1:</strong> Open System Preferencese and then click on the <strong>Profiles</strong> button.",
    step2: "<strong>Step 2:</strong> Choose <strong>GoPaperless Agent Cert</strong> profile and then click <strong>Install</strong> button.",
    step3: "<strong>Step 3:</strong> Click the <strong>Install</strong> button once more time to confirm the installation. ",
    step4: "<strong>Step 4:</strong> Enter computer’s password.",
    step5: "After entering the password, the operating system will automatically add and trust the Certificate Authorities (CAs) in the Keychain."
  },

  uninstallationGopaperlessAgent: {
    step1: "<strong>Step 1:</strong> Close the <strong>GoPaperless Agent</strong> application (if it is currently running).",
    step2: "<strong>Step 2:</strong> Click <strong>Start → open Control Panel.</strong>",
    step3: "<strong>Step 3:</strong> Select <strong>Programs → Programs and Features.</strong>",
    step4: "<strong>Step 4:</strong> In the list of installed programs, select <strong>GoPaperless Agent</strong>.",
    step5: "<strong>Step 5:</strong> Right-click and choose <strong>Uninstall/Change.</strong>",
    step6: "<strong>Step 6:</strong> When the system displays a confirmation message, select <strong>Yes</strong> to proceed with the uninstallation.",
    step7: "<strong>Step 7:</strong> On the <strong>Welcome – GoPaperless Agent Setup (Uninstall)</strong> screen, click <strong>Next</strong> to continue.",
    step8: "<strong>Step 8:</strong> On the Installation Folder screen, click <strong>Uninstall</strong> to start the uninstallation process.",
    step9: "<strong>Step 9:</strong> Wait for the system to complete the uninstallation process.",
    step10: "<strong>Step 10:</strong> Once the process is complete, click <strong>Finish (if available)</strong> to exit.",
  },

  loginGopaperlessAgent: {
    loginMobileID: "<strong>1. Login with Mobile-ID</strong>",
    loginMobileIDstep1: "<strong>Step 1:</strong> Choose login method",
    loginMobileIDstep1sub: "On the login screen, click <strong>Login with Mobile-ID</strong>",
    loginMobileIDstep2: "<strong>Step 2:</strong> Enter account information",
    loginMobileIDstep2sub: "Enter the following information:",
    loginMobileIDstep2sub1: "Username or Email",
    loginMobileIDstep2sub2: "Password",
    loginMobileIDstep2sub3: "Then click <strong>Login</strong>",
    loginMobileIDstep3: "<strong>Step 3:</strong> Login successful",
    loginMobileIDstep3sub: "If the information is valid, the system will log in successfully and display: Digital Certificate Management Interface",
    loginMobileIDstep3sub1: "Digital Certificate Management Interface",
    loginMobileIDstep3sub2: "Here, users can:",
    loginMobileIDstep3sub2item1: "View digital certificates list",
    loginMobileIDstep3sub2item2: "Add new certificate",
    loginMobileIDstep3sub2item3: "View signing history",
    loginMobileIDstep3sub2item4: "Manage certificate information",

    loginGoogle: "<strong>2. Login with Google</strong>",
    loginGoogleStep1: "<strong>Step 1:</strong> Choose login method",
    loginGoogleStep1sub: "On the login screen, click <strong>Login with Google</strong>",
    loginGoogleStep2: "<strong>Step 2:</strong> Choose Google account",
    loginGoogleStep2sub: "The system will redirect to the Google login screen.",
    loginGoogleStep2subitem1: "Select the Google account you want to use \n or",
    loginGoogleStep2subitem2: "Enter your Google email and password (if not logged in)",

    loginVNeID: "<strong>3. Login with VNeID</strong>",
    loginVNeIDStep1: "<strong>Step 1:</strong> Choose login method",
    loginVNeIDStep1sub: "On the application login screen, click: <strong>Login with VNeID</strong>",
    loginVNeIDStep2: "<strong>Step 2:</strong> National Public Service Portal screen",
    loginVNeIDStep2sub: "The system will redirect to the National Portal login screen.",
    loginVNeIDStep2sub1: "There are 2 login methods:",
    loginVNeIDStep2sub1item1: "Login with Personal ID number and Password",
    loginVNeIDStep2sub1item2: "Login with QR code using VNeID app",
    loginVNeIDStep2sub2: "This document demonstrates the QR code method.",
    loginVNeIDStep3: "<strong>Step 3:</strong> Scan QR code with VNeID app",
    loginVNeIDStep3sub: "Follow these steps:",
    loginVNeIDStep3subitem1: "Open the VNeID app on your phone.",
    loginVNeIDStep3subitem2: "Select the QR code scanning function.",
    loginVNeIDStep3subitem3: "Scan the QR code displayed on the computer screen.",
    loginVNeIDStep3subitem4: "Confirm login on the VNeID app (if required).",
    loginVNeIStep4: "<strong>Step 4:</strong> Login successful"
  },

  viewPDC: {
    description: "After logging in to GoPaperless Agent, the system will automatically download the digital certificates from the server into the Windows Keystore to perform digital signing. Users can view and refresh the certificate list when needed.",

    description1: "View Personal Digital Certificates",

    description2: "Users need to log in to <strong>GoPaperless Agent</strong>, then open the application from the <strong>System Tray</strong> by clicking the <strong>GoPaperless Agent</strong> icon and selecting the <strong>GoPaperless Agent</strong> menu.",

    description3: "Double-click any <strong>digital certificate</strong> to view its details. <strong>GoPaperless Agent</strong> uses the <strong>default Windows certificate viewer</strong> to display detailed certificate information.",

    description4: "Click <strong>Refresh</strong> to download new <strong>digital certificates</strong> from the server."
  },

  supportedSign: {
    description: "The VNeID signature authentication feature allows you to digitally sign documents using electronic identity verification.",
    stepbystep: "<strong>The process is as follows:</strong>",
    step1: "<strong>Initialize the signature position</strong> and configure the signature display content on the document.",
    step2: "Click <strong>Sign</strong> to start the authentication process.",
    step3: "The system will <strong>display a “Waiting for Signature” window</strong> and simultaneously send a digital signing confirmation request to the VNeID application on your device.",
    step4: "Complete the <strong>verification on the VNeID application</strong> as instructed (for example: biometric authentication or PIN code).",
    step5: "After successful verification, the <strong>digital signature will be applied to the document</strong> and the signing process will be completed.",
    description2: "This feature ensures legal validity, security, and accurate identity verification of the signer."
  },

  InstallationGuide: {
    description: "<strong>GoPaperless Agent</strong> is a lightweight utility (plug-in) for Microsoft Windows and Apple macOS operating systems that enables remote digital signing of documents, emails, and other data formats (server-based signatures). GoPaperless Agent eliminates the need to deploy smart cards or USB Tokens for end users.",

    description1: "Instead, users' signing keys and digital certificates are centrally managed within the Trusted Hub Service Provider Appliance system. Users can perform remote digital signing directly on any application running on Microsoft Windows or Apple macOS without changing the application's original user experience.",

    description2: "As a result, GoPaperless Agent helps reduce deployment costs while providing a more user-friendly and convenient digital signing experience when working with applications on Windows/macOS."
  },

  messageBox: {
    error: "<strong>Important Notification</strong>",
    errorItem1: "Related to signing rejection, errors, incidents, or issues that require immediate action.",
    errorItem2: "May affect transactions, digital signing processes, or account security.",
    errorItem3: "Users should review and take corrective actions.",

    warning: "<strong>Warning / Reminder</strong>",
    warningItem1: "Provides warnings or reminders (e.g., expiration approaching, information update required).",
    warningItem2: "Not a critical error but should be noted to avoid service interruptions.",

    ok: "<strong>Success / Confirmation</strong>",
    okItem1: "Confirms that an action has been completed successfully (e.g., signing successful, update successful).",
    okItem2: "Or indicates that the system is operating normally."
  },

  word: {
    step1: "<strong>Step 1:</strong> Open the document to be signed",
    step1a: "Open Microsoft Word.",
    step1b: "Create a new document or open an existing document that needs to be signed.",

    step2: "<strong>Step 2:</strong> Select <strong>File → Info</strong>.",

    step3: "<strong>Step 3:</strong> Select <strong>Protect Document</strong>.",

    step4: "<strong>Step 4:</strong> Select <strong>Add a Digital Signature</strong>.",

    step5: "<strong>Step 5:</strong> Verify that the displayed digital certificate is the one you want to use for signing.",

    step6: "<strong>Step 6:</strong> If you want to change the certificate, select <strong>Change</strong>.",

    step7: "<strong>Step 7:</strong> Click <strong>Sign</strong> to start signing.",

    step8: "<strong>Step 8:</strong> An authentication screen will appear.",

    step9: "<strong>Step 9:</strong> Open the VNeID application on your mobile device.",
    step9a: "Go to <strong>Notifications</strong> → Select <strong>Signature request confirmation</strong>.",
    step9b: "Review the information.",
    step9c: "Check the consent box:",
    step9d: "“I have read and clearly understood the purpose (as stated above), my rights and obligations as the data subject, and I agree to these terms.”",
    step9e: "Tap <strong>Confirm Sharing</strong>.",
    step9f: "The application will display <strong>Information shared successfully.</strong>",

    step10: "<strong>Step 10:</strong> Complete the signing process",
    step10a: "The GoPaperless Agent system will display the message: \n <strong>“Signing completed successfully.”</strong>",

    step11: "<strong>Step 11:</strong> Check the signed document. Select <strong>Signed Document</strong> to open it.",

    step12: "<strong>Step 12:</strong> In the <strong>Signature</strong> panel (on the right side), view the signature information.",
    step12des: "To view detailed certificate information:",

    step12a: "Click the <strong>expand icon</strong>",
    step12b: "Select <strong>Signature Details</strong>",
    step12c: "Click <strong>View</strong> to see details",
    step12d: "Click <strong>OK</strong> to finish"
  },

  excel: {
    step1: "<strong>Step 1:</strong> Open the document to be signed",
    step1a: "Open Microsoft Excel.",
    step1b: "Create a new file or open an existing file to sign.",

    step2: "<strong>Step 2:</strong> Select <strong>File → Info</strong>.",
    step3: "<strong>Step 3:</strong> Select <strong>Protect Workbook</strong>.",
    step4: "<strong>Step 4:</strong> Select <strong>Add a Digital Signature</strong>.",
    step5: "<strong>Step 5:</strong> Verify that the displayed certificate is correct.",
    step6: "<strong>Step 6:</strong> If you want to change the certificate, select <strong>Change</strong>.",
    step7: "<strong>Step 7:</strong> Click <strong>Sign</strong> to start signing.",
    step8: "<strong>Step 8:</strong> The authentication waiting screen will appear.",

    step9: "<strong>Step 9:</strong> Open the VNeID application on your mobile device.",
    step9a: "Go to <strong>Notifications</strong> → Select <strong>Digital signing request</strong>.",
    step9b: "Check the information.",
    step9c: "Agree to the terms:",
    step9d: "“I have read and understood the purpose, rights, and obligations...”",
    step9e: "Click <strong>Confirm sharing</strong>.",
    step9f: "The app displays <strong>Information shared successfully.</strong>",

    step10: "<strong>Step 10:</strong> Complete the signing process",
    step10a: "<strong>“Signing completed successfully.”</strong>",

    step11: "<strong>Step 11:</strong> Check the signed document.",
    step12: "<strong>Step 12:</strong> View certificate details.",
    step12des: "To view certificate details:",
    step12a: "Click the expand icon",
    step12b: "Select <strong>Signature Details</strong>",
    step12c: "Click <strong>View</strong> to see details",
    step12d: "Click <strong>OK</strong> to finish"
  },

  ppt: {
    step1: "<strong>Step 1:</strong> Open the document to be signed",
    step1a: "Open Microsoft PowerPoint.",
    step1b: "Create or open a presentation file.",

    step2: "<strong>Step 2:</strong> Select <strong>File → Info</strong>.",
    step3: "<strong>Step 3:</strong> Select Protect Presentation.",
    step4: "<strong>Step 4:</strong> Select Add a Digital Signature.",
    step5: "<strong>Step 5:</strong> Verify the certificate.",
    step6: "<strong>Step 6:</strong> Select <strong>Change</strong> if needed.",
    step7: "<strong>Step 7:</strong> Click <strong>Sign</strong>.",
    step8: "<strong>Step 8:</strong> An authentication screen will appear.",

    step9: "<strong>Step 9:</strong> Open the VNeID application on your mobile device.",
    step9a: "Go to <strong>Notifications</strong> → Select <strong>Digital signing request</strong>.",
    step9b: "Check the information.",
    step9c: "Agree to the terms:",
    step9d: "“I have read and understood the purpose, rights, and obligations...”",
    step9e: "Click <strong>Confirm sharing</strong>.",
    step9f: "The app displays <strong>Information shared successfully.</strong>",

    step10: "<strong>Step 10:</strong> Complete signing",
    step10a: "<strong>“Signing completed successfully.”</strong>",

    step11: "<strong>Step 11:</strong> Check the signed document.",
    step12: "<strong>Step 12:</strong> View certificate details.",
    step12des: "To view certificate details:",
    step12a: "Click the expand icon",
    step12b: "Select <strong>Signature Details</strong>",
    step12c: "Click <strong>View</strong> to see details",
    step12d: "Click <strong>OK</strong> to finish"
  },

  foxit: {
    step1: "<strong>Step 1:</strong> Open the PDF file",
    step1a: "Open Foxit Reader.",
    step1b: "Open the file to sign.",

    step2: "<strong>Step 2:</strong> Select <strong>Protect</strong>.",
    step3: "<strong>Step 3:</strong> Select Sign & Certify → Place Signature.",
    step4: "<strong>Step 4:</strong> Draw the signature area.",
    step5: "<strong>Step 5:</strong> Verify certificate → Click <strong>Sign</strong>.",
    step6: "<strong>Step 6:</strong> An authentication screen will appear.",

    step7: "<strong>Step 7:</strong> Open the VNeID application on your mobile device.",
    step7a: "Go to <strong>Notifications</strong> → Select <strong>Digital signing request</strong>.",
    step7b: "Check the information.",
    step7c: "Agree to the terms:",
    step7d: "“I have read and understood the purpose, rights, and obligations...”",
    step7e: "Click <strong>Confirm sharing</strong>.",
    step7f: "The app displays <strong>Information shared successfully.</strong>",

    step8: "<strong>Step 8:</strong> Complete signing",
    step8a: "<strong>“Signing completed successfully.”</strong>",

    step9: "Double-click the signature.",
    step10: "Open <strong>Signature Properties</strong>.",
    step11: "Show <strong>Certificate</strong> → <strong>OK</strong>"
  },

  acrobatReader: {
    step1: "<strong>Step 1:</strong> Open the PDF file using Adobe Reader.",
    step2: "<strong>Step 2:</strong> Select <strong>Use a certificate</strong>.",
    step3: "<strong>Step 3:</strong> Select <strong>Digitally sign</strong>.",
    step4: "<strong>Step 4:</strong> Click <strong>OK</strong>.",
    step5: "<strong>Step 5:</strong> Draw the signature area.",
    step6: "<strong>Step 6:</strong> Select <strong>certificate</strong>.",
    step7: "<strong>Step 7:</strong> Click <strong>Continue</strong>.",
    step8: "<strong>Step 8:</strong> Configure <strong>signature display (optional)</strong>.",
    step9: "<strong>Step 9:</strong> Click <strong>Sign</strong>.",
    step10: "<strong>Step 10:</strong> An authentication screen will appear.",

    step11: "<strong>Step 11:</strong>  Open the VNeID application on your mobile device.",
    step11a: "Go to <strong>Notifications</strong> → Select <strong>Digital signing request</strong>.",
    step11b: "Check the information",
    step11c: "Agree to the terms:",
    step11d: "“I have read and understood the purpose, rights, and obligations...”",
    step11e: "Click <strong>Confirm</strong>.",
    step11f: "The app displays <strong>Information shared successfully.</strong>",

    step12: "<strong>Step 12:</strong> Complete signing",
    step12a: "<strong>“Signing completed successfully.”</strong>",

    step13: "Double-click the signature to view details."
  },

  useCase: {
    title: "<strong>GoPaperless Agent</strong> does not have a separate user interface (UI) for signing, as it uses the native application UI.",
    des: "Common use cases of <strong>GoPaperless Agent</strong> include:",
    word: "Signing with Microsoft Word",
    excel: "Signing with Microsoft Excel",
    ppt: "Signing with Microsoft PowerPoint",
    foxit: "Signing with Foxit Reader",
    acrobat: "Signing with Acrobat Reader"
  },

  version1_26: {
    release: "<strong>Release Notes</strong> – v1.26.3.18",
    date: "<strong>Release Date:</strong> 18/03/2026",
    environment: "<strong>Environment:</strong> Live",

    newFeatures: "<strong>New Features:</strong>",
    newFeature1: "Support for <strong>system login</strong> with enhanced authentication mechanisms",
    newFeature2: "Integration of <strong>digital signatures in Microsoft Office</strong> (Word, Excel, PowerPoint)",
    newFeature3: "Added digital signing support for <strong>Foxit Reader</strong>",
    newFeature4: "Added digital signing support for <strong>Adobe Reader</strong>",
    newFeature5: "Allow users to <strong>create VNeID digital certificates (CTS)</strong> directly within the system",

    improve: "<strong>Improvements:</strong>",
    improve1: "Enhanced <strong>VNeID digital certificate (CTS) management</strong> for easier tracking and usage",
    improve2: "Improved performance and user experience during the digital signing process",
    improve3: "Optimized processing workflows and data synchronization",

    bugfix: "<strong>Bug Fixes:</strong>",
    bugfix1: "Fixed minor issues related to login",
    bugfix2: "Resolved issues occurring during digital signing across platforms",
    bugfix3: "Improved system stability"
  }
};

export default en;
